import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
declare const L: any;
import 'leaflet-draw';
import { LatLng, Layer } from 'leaflet';
import { get } from 'http';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { take } from 'rxjs';

@Component({
  selector: 'app-asset-holding',
  templateUrl: './asset-holding.component.html',
  styleUrls: ['./asset-holding.component.css']
})
export class AssetHoldingComponent implements OnInit {


  singleObjectInfoData: any = []
  maintenanceScheduleList: any = []
  objectTemplateId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  groupTypeList:any = []
  selectAllChecked: any = false
  isRepairGiven: any = false
  isLock: any = false
  isLockAll: any = false
  isUnLockAll: any = false
  isShowLock: any = false
  objectInfoList: any = []
  userId: any = ""

  holdingType: any = "company"
  uomData: any = []
  objectInfoListFilter: any = []
  singleObjectTemplateData: any = []
  proofFile: any = ""
  proofFilePath: any = ""
  proofFileType: any = ""
  objectTemplateList: any = []
  isLoading: any = false
  objectInfoId: any
  originalCost: any = ""
  currentCost: any = ""
  icon: any = ""
  branch: any = ""
  branchId: any = ""
  department: any = ""
  make: any = ""
  model: any = ""
  objectQty: any = ""
  objectUOM: any = ""
  availableQty: any = ""
  location: any = ""
  objectCondition: any = ""
  assetStatus: any = ""
  givenName: any = ""
  imagesList: any = []
  imagesWithDetails: any = []
  serialNumber: any = ""
  locationList: any = []
  branchList: any = []
  repairInfoForm: any | FormGroup;
  repairFormSubmit: any = false;
  addAsset: any | FormGroup;
  isMaintenanceSchedule: any = false
  maintenanceList:any = []
  assetMonitoring: any = false
  performance: any = false
  timeSpan: any = ""
  expectedOutput: any = ""
  uom: any = ""
  assetMonitoringFrequency: any = 0
  assetMonitoringTimeSpan: any = 0
  assetHealth: any = false
  connectionsList: any = []
  assetHealthList: any = []
  maintenanceType = [
    {
      key: "Preventive Maintenance (PM) Schedule",
      value: "PreventiveMaintenanceSchedule"
    },
    {
      key: "Corrective Maintenance Schedule",
      value: "CorrectiveMaintenanceSchedule"
    },
    {
      key: "Predictive Maintenance Schedule",
      value: "PredictiveMaintenanceSchedule"
    },
    {
      key: "Condition-Based Maintenance (CBM)",
      value: "ConditionBasedMaintenance"
    }
  ]

  frequencyType = [
    {
      key: "Daily: Operational checks (temperature, pressure, noise, etc.)",
      value: "Daily"
    },
    {
      key: "Weekly: Lubrication, filter checks, fluid levels",
      value: "Weekly"
    },
    {
      key: "Monthly: In-depth inspections, cleaning, software updates",
      value: "Monthly"
    },
    {
      key: "Quarterly: Component replacements (belts, seals), diagnostics",
      value: "Quarterly"
    },
    {
      key: "Annually: Major overhauls, part replacements, certifications",
      value: "Annually"
    }
  ]

  assetConditions = [
    { value: 'Good', label: 'Good' },
    { value: 'UnderRepair', label: 'Under Repair' },
    { value: 'Scrap', label: 'Scrap' }
  ];

  isRepair: any = false
  isRepairDone = false
  userCred: any 
  showFilter: any = false
  objectTypeData: any = [];
  objectGroupData: any = [];
  file: any;
  iconFile: any
  largeImage: any = "";
  todayDate: any;
  minEndDate: any;
  editPerformanceMatrix: any = false
  performanceMatrixList: any = [];
  nameValue: any;
  objectColorCode: any = ""
  isObjectColorCode: any = false
  performanceMatrix: any;
  warrantyInfo: any;
  purchaseInfo: any
  acquisitionDate: any = "";
  salvageValue: any;
  depreciationMethod: any;
  putToUseDate: any = "";
  assetLifeNumber: any;
  asset_Category: any = "";
  objectCategoryList: any = [];
  assetDepreciationDataList: any = [];
  departmentInfoList: any = [];
  searchFilter: any = ""
  tags: any = []
  isClone: any = false
  templateName: any;

  recordName: any = ""
  recordId: any = ""
  parentAssetId: any = 0
  isParentAssetId: any = false

  private map!: L.Map;
  private map1!: L.Map;
  private centroid: L.LatLngExpression = [17.4051564, 78.4927618];
  defaultZoom: any = 14
  defaultCenter: L.LatLngExpression = [17.4051564, 78.4927618];
  latlng: any = {
    lat: 0,
    lng: 0
  }
  updatedCoords: any = []
  isLatLng: boolean = false
  objectStatusColor: any = "";
  objectStatus: any = "";

  branchCheckBox: any = false;
  departmentCheckBox: any = false;
  locationCheckBox: any = false;
  makeCheckBox: any = false;
  modelCheckBox: any = false;
  originalCostCheckBox: any = false;
  currentCostCheckBox: any = false;
  serialNumberCheckBox: any = false;
  depreciationCheckbox: any = false;
  quantity: any = false;
  parentAssetIdFlag: any = false;
  warranty: any = false;
  purchase: any = false
  geojsonData: any
  area: any = []
  multiLatLng: any = false;
  assetStatusList: any = []

  isOriginalCost: any = false;
  isAsset_Category: any = false;
  isPutToUseDate: any = false;
  isSalvageValue: any = false;
  isAssetLifeNumber: any = false;


  // objectInfoList:any = [];
  parentSelectedList:any = [];
  parentDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'objectInfoId',
    textField: 'givenName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  jsonString1 = JSON.stringify({
    id: 123,
    asset: 'Epson Multimedia Projector',
    location: 'Karol Bagh'
  });

  branchFilterList: any = []
  locationFilterList: any = []
  departmentFilterList: any = []
  usersList: any = [];
  filteredUsers: any = [];

  searchUser: string = "";
  selectedUserId: any = 0

  constructor(private ngZone: NgZone,private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);
    // this.getAllObjectInfo()
    this.getUsers()
    this.getAllByHoldingUserIdAndCid(0)

  }

  jsonString: string = "";

  getUsers(){
    this.generic_service.getUsers().subscribe(
      (res:any)=>{
        this.usersList = res.response;
        this.filteredUsers = res.response;

        console.log(res);
      }
    )
  }

  onTableDataChange(event: any) {
    console.log(event)
    this.page = event.page+1;
  }
  

  toggleFilter(){
    this.showFilter = !this.showFilter
  }

  refreshAll(){
    this.getAllByHoldingUserIdAndCid(0)
    this.page = 1
    this.first = 0
    this.showFilter = false
    this.searchFilter = ""
    this.selectedUserId = 0
    this.objectInfoList = []
    this.userId = ""
  }

  getObjectTemplateById(objectTemplateId: any){
    this.generic_service.getObjectTemplateById(objectTemplateId.target.value).subscribe(
      (response: any)=>{
        this.singleObjectTemplateData = []

        this.singleObjectTemplateData.push(response.response)
  this.branchCheckBox = response.response.branch || false;
  this.departmentCheckBox = response.response.department || false;
  this.locationCheckBox = response.response.location || false;
  this.makeCheckBox = response.response.make || false;
  this.modelCheckBox = response.response.model || false;
  this.icon = response.response.iconUrl || '';
  this.originalCostCheckBox = response.response.originalCost || false;
  this.currentCostCheckBox = response.response.currentCost || false;
  this.serialNumberCheckBox = response.response.serialNumber || false;
  this.depreciationCheckbox = response.response.depreciationRequired || false;
  this.quantity = response.response.quantity || false;
  
  this.parentAssetIdFlag = response.response.parentAssetIdFlag || false;
  this.warranty = response.response.warranty || false;
  this.purchase = response.response.purchase || false;
        this.openMapPopup()
      },
      (error: any)=>{
        console.log(error)
      }
    )
  }

  getMaintenanceType(type: any){
    for(let list of this.maintenanceType){
      if(list.value == type){
        return list.key
      }
    }
    return ""
  }


  getObjectInfoById(objectInfoId: any){
    this.isLatLng = false
    this.largeImage = ""
    this.objectInfoId = objectInfoId
    this.imagesList = []
    this.imagesWithDetails = []
    this.parentSelectedList = []
    this.removeLatLng()
    this.generic_service.getObjectInfoById(objectInfoId).subscribe(
      (response:any)=>{
        this.singleObjectInfoData = []
        this.singleObjectInfoData.push(response.response)
        this.isRepairGiven = response.response.givenRepair
        this.isLock = response.response.lock
        this.imagesList = response.response.images || []
        this.imagesWithDetails = response.response.imagesWithDetails || []
        this.getAllMaintenanceScheduleByAssetId(objectInfoId)


        let obj = {
          "Id": response.response.objectInfoId || "",
          "Name": response.response.givenName || "",
          "Condition": response.response.objectCondition || "",
        }
        this.jsonString = JSON.stringify(obj);

    this.singleObjectTemplateData = []


for(let list of this.objectTemplateList){
  if(list.name == response.response.name){
    this.objectTemplateId = list.objectTemplateId
    console.log(list)
    console.log(this.objectTemplateId)
    this.singleObjectTemplateData.push(list)
  }
}

  this.branchCheckBox = response.response.branchCheckBox || false;
  this.departmentCheckBox = response.response.departmentCheckBox || false;
  this.locationCheckBox = response.response.locationCheckBox || false;
  this.makeCheckBox = response.response.makeCheckBox || false;
  this.modelCheckBox = response.response.modelCheckBox || false;
  this.originalCostCheckBox = response.response.originalCostCheckBox || false;
  this.currentCostCheckBox = response.response.currentCostCheckBox || false;
  this.serialNumberCheckBox = response.response.serialNumberCheckBox || false;
  this.depreciationCheckbox = response.response.depreciationCheckbox || false;
  this.quantity = response.response.quantity || false;

  this.warranty = response.response.warranty || false;
  this.purchase = response.response.purchase || false;
 this.area = response.response?.area
 this.multiLatLng = response.response?.multiLatLng
if(response.response.lat && response.response.lat != 0 && response.response.lat != null){
  this.latlng.lat = response.response.lat
  this.latlng.lng = response.response.lng
  this.isLatLng = true
 console.log(this.latlng)

}else{
  this.latlng.lat = 0
  this.latlng.lng = 0
  this.isLatLng = false
  this.defaultCenter = [17.4051564, 78.4927618];

}
this.objectColorCode = response.response.objectColorCode || "";

this.templateName = response.response.name;
this.originalCost = response.response.originalCost;
this.objectCondition = response.response.objectCondition;
this.assetStatus = response.response.assetStatus;
this.givenName = response.response.givenName;
this.serialNumber = response.response.serialNumber;
this.imagesList = response.response.images;
this.imagesWithDetails = response.response.imagesWithDetails || [];
this.icon = response.response.icon;
this.currentCost = response.response.currentCost;
this.branch = response.response.branch;
this.department = response.response.department;
this.make = response.response.make;
this.model = response.response.model;
this.location = '';

if(response.response.givenRepair){
  if(response.response.repairInfos){
    for(let list of response.response.repairInfos){
      if(!list.repairDone){
        this.repairInfoForm.patchValue({
          userName: list.userName,
          repairGivenTo: list.repairGivenTo,
          repairGivenDate: list.repairGivenDate,
          repairExpectedEndDate: list.repairExpectedEndDate,
          repairCost: list.repairCost,
          estRepairCost: list.estRepairCost,
          phNo: list.phNo,
          emailId: list.emailId,
          description: list.description,
        })
      }
    }
  }

}

    //     this.repairInfoForm.patchValue({
    //       userName: list.userName,
    //     })

const locationFromResponse = response?.response?.location;

if (locationFromResponse) {
  const found = this.locationList.some((list: any) => list.zone === locationFromResponse);
  if (found) {
    this.location = locationFromResponse;
  }
}

this.assetMonitoring = response.response.assetMonitoring;
this.connectionsList = response.response.connectionDetails || [];
this.assetHealthList = response.response.assetHealth || [];

  this.performance =  response.response.performance || false
  this.timeSpan = response.response?.assetPerformance?.timeSpan || ""
  this.expectedOutput = response.response?.assetPerformance?.expectedOutput || ""
  this.uom = response.response.assetPerformance?.uom || ""
if(this.assetHealthList != null && this.assetHealthList.length != 0){
  this.assetHealth = true
}

if(response.response.parentAssetId && response.response.parentAssetId != 0){
  this.isParentAssetId = true
}else{
  this.isParentAssetId = false

}

this.warranty = response.response.warranty
this.warrantyInfo = response.response.warrantyInfo

this.purchase = response.response.purchase
this.purchaseInfo = response.response.purchaseInfo

this.parentAssetId = response.response.parentAssetId || 0;


this.assetMonitoringFrequency = response.response.assetMonitoringFrequency || 0;
this.assetMonitoringTimeSpan = response.response.assetMonitoringTimeSpan || 0;
this.nameValue = response.response.nameValue;
this.performanceMatrix = response.response.performanceMatrix;
this.acquisitionDate = response.response.acquisitionDate;
this.salvageValue = response.response.salvageValue;
this.depreciationMethod = response.response.depreciationMethod;



this.assetLifeNumber = response.response.assetLifeNumber;
this.asset_Category = response.response.asset_Category;
this.tags = []
if(response.response.tags && response.response.tags != null && response.response.tags != undefined && response.response.tags.length != 0){
  for(let list of response.response.tags){
    this.tags.push({
      "tag": list
    })
  }
}

this.parentAssetIdFlag = response.response.parentAssetIdFlag || false;
this.parentSelectedList = []
if(response.response.parentAssetId && response.response.parentAssetId != null && response.response.parentAssetId != undefined && response.response.parentAssetId.length != 0){
  for(let list of response.response.parentAssetId){
    for(let object of this.objectInfoList){
      if(list == object.objectInfoId){
        this.parentSelectedList.push(
          {
            objectInfoId: object.objectInfoId,
            givenName: object.givenName
          }
        )
      }
    }
  }
}

this.assetMonitoring = response.response.assetMonitoring;
this.connectionsList = response.response.connectionDetails || [];
this.assetHealthList = response.response.assetHealth || [];
if(this.assetHealthList != null && this.assetHealthList.length != 0){
  this.assetHealth = true
}
this.nameValue = response.response.nameValue;
this.performanceMatrix = response.response.performanceMatrix;
this.openMapPopup2()

      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  getAllMaintenanceScheduleByAssetId(objectInfoId: any){
    this.generic_service.getAllMaintenanceScheduleByAssetId(objectInfoId).subscribe(
      (response:any)=>{
        this.maintenanceScheduleList = response.response
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  changeHolding(type: any){
    if(type == 'company'){
      this.showFilter = false
      this.searchFilter = ""
      this.selectedUserId = 0
      this.getAllByHoldingUserIdAndCid(0)
    }else{
      this.showFilter = true
    }
  }

  getAllByHoldingUserIdAndCid(userId: any){
    this.selectedUserId = userId || 0
    this.isLoading = true
    this.generic_service.getAllByHoldingUserIdAndCid(userId).subscribe(
      (response:any)=>{
        this.objectInfoList = response.response || []
        this.count = this.objectInfoList.length || 0
        this.isLoading = false
      },
      (error:any)=>{
        this.isLoading = false
        console.log(error)
      }
    )
  }

  getAllObjectInfo(){
    this.generic_service.getAllObjectInfo().subscribe(
      (response:any)=>{
        this.objectInfoList = response.response
        this.objectInfoListFilter = response.response
        this.count = response.response.length
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  remove(){
    document.getElementById("closeModalButton")?.click()
    this.singleObjectTemplateData = []
    this.objectTemplateId = ""
    this.originalCost = ""
    this.currentCost = ""
    this.branch = ""
    this.department = ""
    this.objectCondition = ""
    this.assetStatus = "" 
    this.givenName = ""
    this.location = ""
    this.serialNumber = ""
    this.largeImage = ""
    this.maintenanceList = []
    this.imagesList = []
    this.imagesWithDetails = []
    this.assetHealth = false
    this.assetMonitoring = false
    this.connectionsList = []
    this.assetHealthList = []
    this.isClone = false
    this.objectInfoId = ""
    this.repairInfoForm.reset()

    this.singleObjectInfoData = []
    this.isRepairGiven = false
    this.imagesList = []
    this.imagesWithDetails = []
    this.singleObjectTemplateData = []
    this.parentSelectedList = []

    this.isLock = false

    this.templateName = "";
    this.originalCost = null;
    this.objectCondition = "";
    this.assetStatus = ""
    this.givenName = "";
    this.serialNumber = "";
    this.imagesList = [];
    this.imagesWithDetails = []
    this.icon = "";
    this.currentCost = null;
    this.branch = "";
    this.branchId = ""
    this.department = "";
    this.make = "";
    this.model = "";
    this.location = "";
    this.assetMonitoring = false;
    this.connectionsList = [];
    this.assetHealthList = [];
    this.assetHealth = false
    this.assetMonitoringFrequency = null;
    this.assetMonitoringTimeSpan = null;
    this.nameValue = [];
    this.performanceMatrix = [];
    this.acquisitionDate = "";
    this.salvageValue = null;
    this.depreciationMethod = null;
    this.assetLifeNumber = null;
    this.asset_Category = "";
    this.tags = []
    this.parentSelectedList = []

    this.timeSpan = ""
    this.expectedOutput = ""
    this.uom = ""
    this.parentAssetId = 0

    this.isOriginalCost = false;
    this.isAsset_Category = false;
    this.isPutToUseDate = false;
    this.isSalvageValue = false;
    this.isAssetLifeNumber = false;
    this.proofFile = ""
    this.proofFileType = ""
    this.proofFilePath = ""
  }

  openMapPopup(): void {

    setTimeout(() => {
      this.initMap();
      this.map.invalidateSize();
    }, 500);
  }

  openMapPopup1(): void {

    setTimeout(() => {
      this.initMap1();
      this.map.invalidateSize();
    }, 500);
  }

  openMapPopup2(): void {

    setTimeout(() => {
      this.initMap2();
      this.map.invalidateSize();
    }, 500);
  }


  marker!: L.Marker;

  initMap(): void {
    this.map = L.map('map', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; OpenStreetMap contributors'
    });

    this.map.on('click', (event: L.LeafletMouseEvent) => {
      this.placeMarker(event.latlng);
    });

    tiles.addTo(this.map);
  }

  initMap1(): void {

    if(this.isLatLng){
      this.defaultCenter = [this.latlng.lat, this.latlng.lng]
      console.log(this.defaultCenter)
    }


    this.map = L.map('map1', {
      center: this.defaultCenter,
      zoom: this.defaultZoom
    });

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 22,
      minZoom: 2,
      attribution: '&copy; OpenStreetMap contributors'
    });

    this.map.on('click', (event: L.LeafletMouseEvent) => {
      this.placeMarker(event.latlng);
    });

    tiles.addTo(this.map);

    if(this.isLatLng){

      this.marker = L.marker([this.latlng.lat,this.latlng.lng])
        .addTo(this.map)
    }
  }

drawnItems!: L.FeatureGroup;



initMap2(): void {
  if (this.isLatLng && this.latlng) {
    this.defaultCenter = [this.latlng.lat, this.latlng.lng];
    console.log(this.defaultCenter);
  }

  this.map = L.map('map2', {
    center: this.defaultCenter,
    zoom: this.defaultZoom
  });

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 22,
    minZoom: 2,
    attribution: '&copy; OpenStreetMap contributors'
  }).addTo(this.map);

  this.map.on('click', (event: L.LeafletMouseEvent) => {
    if(!this.multiLatLng){
      this.placeMarker(event.latlng);
    }
  });

  if (this.isLatLng && this.latlng) {
    this.marker = L.marker([this.latlng.lat, this.latlng.lng]).addTo(this.map);
  }

  // ✅ Initialize drawnItems as editable layer group
  this.drawnItems = L.featureGroup().addTo(this.map);

  // ✅ Add draw control (only edit existing, no new shapes)
  const drawControl = new L.Control.Draw({
    edit: {
      featureGroup: this.drawnItems,
      remove: false // ❌ Disable deletion if needed
    },
    draw: {
      marker: false,
      polygon: false,
      polyline: false, // ✅ Prevent drawing new lines
      circle: false,
      rectangle: false,
      circlemarker: false
    }
  });
  this.map.addControl(drawControl);

  // ✅ Load GeoJSON and make it editable
  const multiLatLng = this.singleObjectInfoData?.[0]?.multiLatLng;
  const area = this.area;
  console.log(multiLatLng)
  console.log(area)
  if (multiLatLng && area.length > 0) {
    const coordinates: [number, number][] = area.map((point: any) => [
      parseFloat(point.lng),
      parseFloat(point.lat)
    ]);

    this.geojsonData = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          properties: { name: 'Polygon' },
          geometry: {
            type: 'LineString',
            coordinates: coordinates
          }
        }
      ]
    };

    const geojsonLayer = L.geoJSON(this.geojsonData, {
      color: this.singleObjectInfoData?.[0]?.objectColorCode || "black",
      weight: 7
    });

    if(coordinates && coordinates.length != 0){
      this.isObjectColorCode = true
    }else{
      this.isObjectColorCode = false
    }

    // ✅ Add to drawnItems to make editable
    geojsonLayer.eachLayer((layer: Layer) => {
      this.drawnItems.addLayer(layer);
    });

    // ✅ Center map on editable shapes
    this.map.fitBounds(this.drawnItems.getBounds());
  }

  // ✅ Listen to edit events
  this.map.on(L.Draw.Event.EDITED, (e: any) => {
    const layers = e.layers;
    layers.eachLayer((layer: any) => {
      const updatedGeoJSON = layer.toGeoJSON();

      // ✅ Convert coordinates back to your API format
      const updatedCoords = updatedGeoJSON.geometry.coordinates.map(
        (coord: [number, number]) => ({
          lat: coord[1].toFixed(8),
          lng: coord[0].toFixed(8)
        })
      );

      this.updatedCoords = updatedCoords
      this.area = updatedCoords
      console.log('✅ Updated Coordinates:', updatedCoords);

      // TODO: Save updatedCoords to your backend via API
      // this.saveUpdatedArea(updatedCoords);
    });
  });
}


  mapCenter(){
    this.map.remove();
    this.singleObjectInfoData = []
    setTimeout(() => {
      if (this.map) {
        this.map.invalidateSize();
        this.map.setView(this.defaultCenter, this.map.getZoom());
      }
    }, 500);
    this.initMap2()

  }

  placeMarker(latlng: L.LatLng): void {
    console.log(latlng)
    this.isLatLng = true

    // Remove existing marker if needed
    this.latlng = latlng
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }

    // Create new marker
    this.marker = L.marker(latlng)
      .addTo(this.map)
      // .bindPopup(`📍 You clicked here:<br>Lat: ${latlng.lat.toFixed(5)}, Lng: ${latlng.lng.toFixed(5)}`)
      // .openPopup();
  }

  removeLatLng(){
    this.isLatLng = false
    this.latlng = {}
    if (this.marker) {
      this.map.removeLayer(this.marker);
    }
  }

  geojsonLayer!: L.GeoJSON; // Add this to your component class

resetEditLatLng() {
  this.latlng = {};

  // Remove existing marker
  if (this.marker) {
    this.map.removeLayer(this.marker);
  }

  // ❌ THIS was incorrect: this.geojsonData is not a Leaflet layer
  // ✅ Correct: remove actual geojsonLayer from map
  if (this.geojsonLayer) {
    this.map.removeLayer(this.geojsonLayer);
  }

  // Clear drawnItems if needed
  if (this.drawnItems) {
    this.drawnItems.clearLayers();
  }

  // Add marker
  if (this.singleObjectInfoData[0].lat && this.singleObjectInfoData[0].lat != 0 && this.singleObjectInfoData[0].lat != null) {
    this.latlng.lat = this.singleObjectInfoData[0].lat;
    this.latlng.lng = this.singleObjectInfoData[0].lng;
    this.isLatLng = true;

    let latlng = L.latLng(this.latlng.lat, this.latlng.lng);
    this.placeMarker(latlng);
    this.map.setView(latlng, this.map.getZoom());
  }

  // Add polyline (LineString)
  if (this.singleObjectInfoData[0].area && this.singleObjectInfoData[0].area.length !== 0) {
    const area = this.singleObjectInfoData[0].area;

    const coordinates: [number, number][] = area.map((point: any) => [
      parseFloat(point.lng),
      parseFloat(point.lat)
    ]);

    this.geojsonData = {
      type: 'FeatureCollection',
      features: [
        {
          type: 'Feature',
          properties: { name: 'Polygon' },
          geometry: {
            type: 'LineString',
            coordinates: coordinates
          }
        }
      ]
    };

    // ✅ Store geojson layer reference
    this.geojsonLayer = L.geoJSON(this.geojsonData, {
      style: {
        color: 'black',
        weight: 4
      }
    });

    this.geojsonLayer.eachLayer((layer: L.Layer) => {
      this.drawnItems.addLayer(layer);
    });

    this.map.fitBounds(this.drawnItems.getBounds());
  }
}

searchClear(){
  this.searchFilter = ""
  this.selectedUserId = 0
  this.filterByUserName()
}


filterByUserName(): void {
  const filterValue = this.searchFilter.trim().toLowerCase();

  if (filterValue) {
    this.filteredUsers = this.usersList.filter((user: any) =>
      user.userName?.toLowerCase().includes(filterValue)
    );
  } else {
    this.filteredUsers = [...this.usersList];
  }
}



  selectLargeImage(largeImage: any){
    this.largeImage = largeImage
  }

}